import { Component, HostBinding, OnInit } from '@angular/core';
import { ConfigService } from '../../config/config.service';
import { CalendlyService } from '../../config/calendly.service';
import { DataLayerService } from '../../shared/services/data-layer.service';
import { AmplitudeService } from '../../shared/services/amplitude.service';
import { AccountService } from '../../shared/services/account.service';
import { AlertPaymentService } from '../../shared/services/alert-payment.service';
import { isCurrentRouteBlocked } from '../../../../old-crazy-web-frontend/src/app/auth/blocked-state-routes';

@Component({
  selector: 'cc-left-menu',
  templateUrl: './left-menu.component.html',
  styleUrls: ['./left-menu.component.scss']
})
export class LeftMenuComponent implements OnInit {
  @HostBinding('class') hostClass = 'app-aside modal fade nav-dropdown';
  @HostBinding('id') hostId = 'aside';

  public failedPayment: boolean;

  constructor(
    private configService: ConfigService,
    private calendlyService: CalendlyService,
    private dataLayerService: DataLayerService,
    private amplitudeService: AmplitudeService,
    private accountService: AccountService,
    public alertPaymentService: AlertPaymentService
  ) {}

  ngOnInit() {
    this.accountService.isAccountSet$.subscribe(() => {
      this.alertPaymentService.onActivatePaymentAlert.subscribe(isPaymentFailed => {
        this.failedPayment = isPaymentFailed;
      });
      this.alertPaymentService.alertUnpaidStatus();
    });
  }

  get blurred() {
    return isCurrentRouteBlocked();
  }

  openCalendly() {
    this.dataLayerService.logEvent('getDemo');
    this.amplitudeService.logEvent('Panel: Page View: Get Demo');
    this.calendlyService.openCalendly();
  }
}
